import { render, staticRenderFns } from "./AccountingCategory.vue?vue&type=template&id=508489df"
import script from "./AccountingCategory.vue?vue&type=script&lang=js"
export * from "./AccountingCategory.vue?vue&type=script&lang=js"
import style0 from "./AccountingCategory.vue?vue&type=style&index=0&id=508489df&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports